import MenuItem from "@material-ui/core/MenuItem";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { isNaN, useField, useFormikContext } from "formik";
import React, { useCallback } from "react";

export type SelectOption = {
    label: string;
    value: string;
};

export type SelectOptions = SelectOption[];

type InputProps = {
    name: string;
    options?: SelectOption[];
    value?: string | null;
} & Omit<TextFieldProps, "name" | "value" | "error" | "variant">;

export default function Input(props: InputProps) {
    const { name, options, ...otherProps } = props;
    const { isSubmitting } = useFormikContext();
    const fieldProps = useField(name);

    const isSelect = !!options;

    const [field, meta] = fieldProps;
    let { value } = field;
    const fieldError = meta.error;
    const showError = meta.touched && !!fieldError;

    const disabled = props.disabled || isSubmitting;
    const helperText = showError ? fieldError : props.helperText;

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            field.onChange(e);
            props.onChange?.(e);
        },
        [field, props.onChange],
    );

    value = isNaN(value) ? "" : value ?? props.value ?? "";

    return (
        <TextField
            {...otherProps}
            {...field}
            value={value}
            select={isSelect}
            onChange={onChange}
            error={showError}
            disabled={disabled}
            helperText={helperText}>
            {isSelect &&
                options!.map(({ label, value: optionValue }) => (
                    <MenuItem key={optionValue} value={optionValue}>
                        {label}
                    </MenuItem>
                ))}
        </TextField>
    );
}
